$(document).ready(function () {
  $(".variant-wrapper").each(function () {
    var $variantButton = $(this).find(".variant__button-label").first();
    // Perform an action on each .variant__button-label within its variant-wrapper
    if ($variantButton.length > 0) {
      $variantButton.click();
      // You can add additional actions or logic related to each variant-wrapper here
    } else {
      console.log("No .variant__button-label found in this variant-wrapper");
    }
  });

  $(".accordion-collapse").on("shown.bs.collapse", function (e) {
    var $panel = $(this).closest(".accordion-item");
    var scrollTo = $panel.offset().top - 120;

    $("html,body").animate(
      {
        scrollTop: scrollTo,
      },
      500
    );
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll('a[href^="mailto:"]');
  links.forEach((link) => {
    const originalHref = link.getAttribute("href");
    const email = originalHref.replace("mailto:", "");
    const [user, domain] = email.split("@");
    link.removeAttribute("target");
    link.setAttribute("href", "#");
    link.setAttribute(
      "onclick",
      `window.open('mai'+'lto:'+'${user}'+'@'+'${domain}');return false;`
    );
    if (link.textContent.trim() === email) {
      link.textContent = "Contact us";
    }
  });
});
(function () {
  // Function to apply styles
  function applyGilroyFont() {
    const divElement = document.getElementById(
      "omnisend-embedded-v2-6639ec64fbff0b5b335be59a"
    );
    if (divElement) {
      // Separate headings from other elements
      const headings = divElement.querySelectorAll("h1, h2, h3, h4, h5, h6");
      const otherElements = divElement.querySelectorAll(
        "p, span, label, input, button"
      );

      // Apply Gilroy-Bold to headings
      headings.forEach((element) => {
        element.style.setProperty("font-family", "Gilroy-Bold", "important");
      });

      // Apply Gilroy to other elements
      otherElements.forEach((element) => {
        element.style.setProperty("font-family", "Gilroy", "important");
      });

      const totalElements = headings.length + otherElements.length;
      if (totalElements > 0) {
        console.log(
          `Updated font-family for ${totalElements} elements (Headings: ${headings.length}, Others: ${otherElements.length})`
        );
        return true; // Success
      }
    }
    return false; // Not ready yet
  }

  // Initial attempt
  if (applyGilroyFont()) {
    return;
  }

  // Set up MutationObserver
  const observer = new MutationObserver((mutations, obs) => {
    if (applyGilroyFont()) {
      obs.disconnect(); // Stop observing once applied
    }
  });

  // Start observing the document body
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Fallback timeout after 15 seconds
  setTimeout(() => {
    observer.disconnect();
    if (
      !document.getElementById("omnisend-embedded-v2-6639ec64fbff0b5b335be59a")
    ) {
      console.error("Div not found after 15 seconds");
    } else if (
      !document.querySelector(
        "#omnisend-embedded-v2-6639ec64fbff0b5b335be59a p, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a span, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a h1, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a h2, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a h3, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a h4, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a h5, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a h6, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a label, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a input, #omnisend-embedded-v2-6639ec64fbff0b5b335be59a button"
      )
    ) {
      console.error("No target elements found in div after 15 seconds");
    }
  }, 15000);
})();
